import mediator from "@tvg/mediator";

export const onSuccessAuthenticationGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:SUCCESS_AUTHENTICATION",
    payload: {
      eventLabel: module,
      module
    }
  });

export const onButtonClickGtmEvent = (eventLabel, module) => {
  mediator.base.dispatch({
    type: "REGISTRATION:SUCCESS_AUTHENTICATION_CTA_CLICK",
    payload: {
      eventLabel,
      module
    }
  });
};
